import { Flex, Text } from '@radix-ui/themes';
import { Auction } from '@prisma/client';
import Link from 'next/link';
import { truncateString, ordinal } from '@/lib/utils';
import { AUCTION_TITLE_TRUNCATION_LENGTH } from '@/lib/constants';
import AuctionStatusBadge from '../../admin/auctions/[auctionId]/_components/AuctionStatusBadge';
import { NoSsr } from '@mui/material';
import { format } from 'date-fns';

interface Props {
  currentAuction: Auction | undefined;
}

const OverviewTitle = ({ currentAuction }: Props) => {
  if (currentAuction) return (
    <Link href={`/admin/auctions/${currentAuction.id}/settings`}>
      <Flex direction="column">
        <Flex justify="between">
          <Text className="text-xl font-semibold">
            {truncateString(
              currentAuction.title,
              AUCTION_TITLE_TRUNCATION_LENGTH
            )}
          </Text>
          <AuctionStatusBadge
            state={currentAuction.auctionState}
            className="text-sm font-medium px-3 rounded-xl"
          />
        </Flex>
        <NoSsr>
          <Text className="text-zinc-500" suppressHydrationWarning>
            Current Auction: {format(currentAuction.startDate, "MMMM do yyyy")} to {format(currentAuction.endDate, "MMMM do yyyy")}
          </Text>
        </NoSsr>
      </Flex>
    </Link>
  );

  return (
    <Flex direction="column">
      <Text className="text-xl font-semibold">
        No active auction
      </Text>
    </Flex>
  );
};

export default OverviewTitle; 